import { useRef, useEffect, MutableRefObject, useState } from "react";
import SignaturePad from "signature_pad";

type SignatureControllers = {
  signPad?: SignaturePad;
  canvasRef: MutableRefObject<HTMLCanvasElement | null>;
  isSignEmpty: () => boolean;
};

/**
 * @description Custom Hook to Manage the Signature input
 *
 * @returns {SignatureControllers} SignatureControllers
 *
 * @link [https://www.npmjs.com/package/signature_pad]
 *
 * @author Rajkumar Rathod
 */
export const useSignatureController = (
  reInitializeSignPad?: boolean,
  prefilledSign?: string
): SignatureControllers => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [signPad, setSignPad] = useState<SignaturePad>();

  // useEffect(() => {
  //   setTimeout(() => {
  //     const canvas = canvasRef.current;
  //     if (canvas) signPad.current = new SignaturePad(canvas);
  //   }, 0);
  // }, [reInitializeSignPad]);
  useEffect(() => {
    setTimeout(() => {
      const canvas = canvasRef.current;
      if (canvas) {
        setSignPad(new SignaturePad(canvas));

        if (prefilledSign) {
          try {
            signPad?.fromDataURL(prefilledSign);
          } catch (e) {
            console.error("Error loading prefilled signature:", e);
          }
        }
      }
    }, 0);
  }, [reInitializeSignPad, prefilledSign]);

  function isSignEmpty(): boolean {
    if (!canvasRef.current && signPad?.isEmpty()) return true;

    if (canvasRef?.current) {
      const ctx = canvasRef.current?.getContext("2d");
      const imgData = ctx?.getImageData(
        0,
        0,
        canvasRef.current.width,
        canvasRef.current.height
      );

      return !!imgData?.data.every((it) => it === 0);
    }

    return !!signPad?.isEmpty();
  }

  return {
    canvasRef,
    signPad: signPad,
    isSignEmpty,
  };
};
